import { createSlice, createAction } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { CarCareAppointment } from "../types";

interface CarCareAppointmentState {
	carCareAppointment?: CarCareAppointment;
}

const initialState: CarCareAppointmentState = {};

export const carCareAppointmentSlice = createSlice({
	name: "carCareAppointment",
	initialState,
	reducers: {
		setCarCareAppointment: (state, action) => {
			state.carCareAppointment = action.payload.data;
		},
	},
});

export const selectCarCareAppointment = (state: RootState) =>
	state.carCareAppointment.carCareAppointment;

export const { setCarCareAppointment } = carCareAppointmentSlice.actions;

export interface GetCarCareAppointmentDetailPayload {
	id: string;
	callback?: () => void;
}

export const getCarCareAppointmentDetailAsync = createAction(
	"carCareAppointment/getCarCareAppointmentDetail",
	(payload: GetCarCareAppointmentDetailPayload) => ({
		payload: payload,
	}),
);

export default carCareAppointmentSlice.reducer;
